/** Keep ZIP codes as text so leading zeroes survive typing, paste, and prefill. */
export function normalizeUsZipCode(value: string): string {
  return value.replace(/\D/g, "").slice(0, 5);
}

export function isValidUsZipCode(value: string): boolean {
  return /^[0-9]{5}$/.test(value);
}
